import { DataCache, DataCacheCollection, ForeignKeyRelationship, SharedKeyRelationship, QueryResultsRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { LloydServiceSearch } from 'data/models/LloydServiceSearch';
import { MarineTrafficServiceSearch } from 'data/models/MarineTrafficServiceSearch';
import { PSixServiceSearch } from 'data/models/PSixServiceSearch';
import { VesselServiceConfigure } from 'data/models/VesselServiceConfigure';

export class VesselServiceConfigureCache extends DataCache {
    LloydServiceSearches                  = PCCollection(LloydServiceSearch                   );
    MarineTrafficServiceSearches          = PCCollection(MarineTrafficServiceSearch           );
    PSixServiceSearches                   = PCCollection(PSixServiceSearch                    );
    VesselServiceConfigures               = PCCollection(VesselServiceConfigure               );

    constructor(data : PCCache) {
        super();

        new QueryResultsRelationship(this.LloydServiceSearches,         data.LloydServiceVessels,         s => s.Results);
        new QueryResultsRelationship(this.MarineTrafficServiceSearches, data.MarineTrafficServiceVessels, s => s.Results);
        new QueryResultsRelationship(this.PSixServiceSearches,          data.PSixServiceVessels,          s => s.Results);
        new QueryResultsRelationship(this.VesselServiceConfigures,      data.Vessels,                     c => c.DuplicateVessels);
        new SharedKeyRelationship   (this.VesselServiceConfigures,      data.Vessels,                     c => c.Vessel, null);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/vesselserviceconfigure/cache.ts